export class KpiSearchFields {
  CustomerId: number;
  LabIds: any;
  ReceivedDateFrom: string;
  ReceivedDateTo: string;
  LabName: string;
  PageNo: number;
  PageSize: number;
  IsForExcel: boolean;
}
export class ConsolidatedSearchFields {
  // AreaId:number;
  // Equipment:string;
  // OilGradeId:number; 
  SampleNo: number;
  SpId: number;
  CustomerId: number;
  LabIds: any;
  JobCardNumber: string;
  ReceivedDateFrom: string;
  ReceivedDateTo: string;
  SampleStatusTypeId: number;
  SampleTypeId: number;
  PageNo: number;
  PageSize: number;
  IsForExcel: boolean;
  IsList: boolean;
}